import { useState, type ReactNode } from 'react'
import type { PermKey, PermSpec } from '../../types'
import {
  ChartLineIcon,
  CheckIcon,
  ClipboardListIcon,
  InfoIcon,
  LayersMinusIcon,
  PencilIcon,
  ReceiptTextIcon,
  SendToBackIcon,
  SettingsIcon,
  UserIcon,
  UtensilsIcon,
  XIcon,
} from '../icons'
import '../chips.css'

const ICONS: Record<PermKey, ReactNode> = {
  order: <ReceiptTextIcon />,
  moveTable: <SendToBackIcon />,
  editPrice: <PencilIcon />,
  track: <ClipboardListIcon />,
  editTicket: <LayersMinusIcon />,
  menu: <UtensilsIcon />,
  reports: <ChartLineIcon />,
  staff: <UserIcon />,
  settings: <SettingsIcon />,
}

/**
 * Personel yetkileri (Ayarlar > Kullanıcılar), kurum özellikleriyle aynı
 * yüzen çipler (25 Eki 2026, kullanıcı): çipe basmak yetkiyi açıp kapatıyor,
 * yanındaki "i" açıklamayı altta gösteriyor. Açık yetki yeşil, onay işaretli.
 */
export function PermChips({
  label,
  options,
  isOn,
  onToggle,
}: {
  label: string
  options: PermSpec[]
  isOn: (perm: PermSpec) => boolean
  onToggle: (perm: PermSpec, on: boolean) => void
}) {
  const [info, setInfo] = useState<PermKey | null>(null)
  const shown = options.find((p) => p.key === info)

  return (
    <div className="fchips ucard__chips" role="group" aria-label={label}>
      <div className="fchips__list">
        {options.map((perm) => {
          const on = isOn(perm)
          return (
            <div key={perm.key} className={`fchip ${on ? 'is-on' : ''} ${info === perm.key ? 'is-info' : ''}`}>
              <button
                type="button"
                role="switch"
                aria-checked={on}
                className="fchip__toggle"
                onClick={() => onToggle(perm, !on)}
              >
                <span className="fchip__icon">{on ? <CheckIcon /> : ICONS[perm.key]}</span>
                {perm.name}
              </button>
              <button
                type="button"
                className="fchip__info"
                aria-label={`${perm.name} nedir?`}
                aria-expanded={info === perm.key}
                onClick={() => setInfo(info === perm.key ? null : perm.key)}
              >
                <InfoIcon />
              </button>
            </div>
          )
        })}
      </div>

      {shown && (
        <div className="fchips__box" role="note">
          <span className="fchips__box-icon">{ICONS[shown.key]}</span>
          <div>
            <strong>{shown.name}</strong>
            <p>{shown.description}</p>
          </div>
          <button type="button" className="fchips__x" aria-label="Kapat" onClick={() => setInfo(null)}>
            <XIcon />
          </button>
        </div>
      )}
    </div>
  )
}
